export default {"src":"/_next/static/media/menu-orders.129b1404.svg","height":20,"width":18};